export default __webpack_public_path__ + "static/media/Parent_Illustrations-12.df32f822.svg";